import * as angular from 'angular';

import { ComponentDefinition, SeriesSelectorViewModel } from '../../../models';

class SerieIconController implements angular.IComponentController {
    serie: SeriesSelectorViewModel;
    static $inject = [];

}

export const wtSerieIcon: ComponentDefinition = {
    componentId: 'wtSerieIcon',
    controller: SerieIconController,
    template: require('./serieIcon.component.html'),
    controllerAs: 'vm',
    bindings: {
        serie: '<', // enum SelectorType
    }
};
